// created from 'create-ts-index'

export * from './regionales-core-detail.model';
export * from './regionales-core.model';
